import React, { useEffect, useState } from "react";

const ScriptLoader = ({ scriptId, scriptSrc, isLoadedCallback }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const onLoad = () => {
      setIsLoaded(true);
      isLoadedCallback(true);
    };
    const loadScript = () => {
      const s = document.createElement("script");
      if (scriptId) {
        s.id = scriptId;
      }
      s.type = "text/javascript";
      s.async = true;
      s.src = scriptSrc;
      s.onreadystatechange = element => {
        if (
          element.readyState === "complete" ||
          element.readyState === "loaded"
        ) {
          onLoad(s);
        }
      };
      s.onload = () => onLoad();
      document.getElementsByTagName("head")[0].appendChild(s);
    };
    if (!isLoaded) {
      loadScript();
    }
  }, [isLoaded, scriptId, scriptSrc, isLoadedCallback]);
  return <></>;
};

export default ScriptLoader;
